module.exports = __webpack_public_path__ + "media/images/jardin-d7967827fa26b9c622d6f1d3071416b2.svg";